import { styled } from "goober";
import { type Ref, useId, useState } from "react";
import { Box } from "./Box";
import { NoteTextarea } from "./NoteTextarea";
import { Text } from "./Text";

const Wrapper = styled("div")`
  display: flex;
  flex-direction: column;
`;

const HelperText = styled("div")`
  display: flex;
`;

const HelperRow = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 8px 8px 6px;
`;

type Props = {
  inputRef?: Ref<HTMLTextAreaElement>;
  label: string;
  hideLabel?: boolean;
  helperText: string;
  maxLength: number;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
};

export function NoteInput({
  inputRef,
  label,
  hideLabel = false,
  helperText,
  maxLength,
  value,
  defaultValue,
  placeholder,
  readOnly,
  disabled,
  onChange,
  onBlur,
}: Props) {
  const id = useId();
  const [length, setLength] = useState(defaultValue?.length ?? 0);
  return (
    <Wrapper>
      {!hideLabel && (
        <Box horizontal={8} vertical={10}>
          <label htmlFor={id}>
            <Text variant="text-small-md" color="var(--text-primary)">
              {label}
            </Text>
          </label>
        </Box>
      )}
      <NoteTextarea
        ref={inputRef}
        id={id}
        aria-label={hideLabel ? label : undefined}
        aria-describedby={`${id}-helper`}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        readOnly={readOnly}
        disabled={disabled}
        maxLength={maxLength}
        onChange={(event) => {
          const next = event.target.value.slice(0, maxLength);
          setLength(next.length);
          onChange?.(next);
        }}
        onBlur={(event) => onBlur?.(event.target.value)}
      />
      <HelperRow>
        <HelperText id={`${id}-helper`}>
          <Text variant="text-small" color="var(--text-secondary)">
            {helperText}
          </Text>
        </HelperText>
        {!readOnly && (
          <Text
            variant="text-small"
            color="var(--text-secondary)"
            style={{ flexShrink: 0 }}
          >
            {value?.length ?? length} / {maxLength}
          </Text>
        )}
      </HelperRow>
    </Wrapper>
  );
}
